import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _dec4, _obj, _init;
/* import __COLOCATED_TEMPLATE__ from './group-card-contents.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import { alias, gt } from "@ember/object/computed";
import { service } from "@ember/service";
import { Promise } from "rsvp";
import { setting } from "discourse/lib/computed";
import { groupPath } from "discourse/lib/url";
import { modKeysPressed } from "discourse/lib/utilities";
import CardContentsBase from "discourse/mixins/card-contents-base";
import CleansUp from "discourse/mixins/cleans-up";
import discourseComputed from "discourse-common/utils/decorators";
import TEMPLATE from "./group-card-contents.hbs";
const maxMembersToDisplay = 10;
export default setComponentTemplate(TEMPLATE, Component.extend(CardContentsBase, CleansUp, (_dec = discourseComputed("group.members.[]"), _dec2 = discourseComputed("group.user_count", "group.members.[]"), _dec3 = discourseComputed("group.name"), _dec4 = discourseComputed("group"), (_obj = {
  composer: service(),
  elementId: "group-card",
  mentionSelector: "a.mention-group",
  classNames: ["no-bg", "group-card"],
  classNameBindings: ["visible:show", "showBadges", "hasCardBadgeImage", "isFixed:fixed", "groupClass"],
  allowBackgrounds: setting("allow_profile_backgrounds"),
  showBadges: setting("enable_badges"),
  postStream: alias("topic.postStream"),
  showMoreMembers: gt("moreMembersCount", 0),
  group: null,
  highlightedMembers(members) {
    return members.slice(0, maxMembersToDisplay);
  },
  moreMembersCount(memberCount) {
    return Math.max(memberCount - maxMembersToDisplay, 0);
  },
  groupClass: name => name ? `group-card-${name}` : "",
  groupPath(group) {
    return groupPath(group.name);
  },
  _showCallback(username, $target) {
    this._positionCard($target);
    this.setProperties({
      visible: true,
      loading: true
    });
    return this.store.find("group", username).then(group => {
      this.setProperties({
        group
      });
      if (!group.flair_url && !group.flair_bg_color) {
        group.set("flair_url", "fa-users");
      }
      return group.can_see_members && group.members.length < maxMembersToDisplay ? group.reloadMembers({
        limit: maxMembersToDisplay
      }, true) : Promise.resolve();
    }).catch(() => this._close()).finally(() => this.set("loading", null));
  },
  _close() {
    this.set("group", null);
    this._super(...arguments);
  },
  cleanUp() {
    this._close();
  },
  close(event) {
    event?.preventDefault();
    this._close();
  },
  handleShowGroup(group, event) {
    if (event && modKeysPressed(event).length > 0) {
      return false;
    }
    event?.preventDefault();
    // Invokes `showGroup` argument. Convert to `this.args.showGroup` when
    // refactoring this to a glimmer component.
    this.showGroup(group);
    this._close();
  },
  actions: {
    cancelFilter() {
      const postStream = this.postStream;
      postStream.cancelFilter();
      postStream.refresh();
      this._close();
    },
    messageGroup() {
      this.composer.openNewMessage({
        recipients: this.get("group.name"),
        hasGroups: true
      });
    },
    showGroup(group) {
      this.handleShowGroup(group);
    }
  }
}, (_applyDecoratedDescriptor(_obj, "highlightedMembers", [_dec], Object.getOwnPropertyDescriptor(_obj, "highlightedMembers"), _obj), _applyDecoratedDescriptor(_obj, "moreMembersCount", [_dec2], Object.getOwnPropertyDescriptor(_obj, "moreMembersCount"), _obj), _applyDecoratedDescriptor(_obj, "groupClass", [_dec3], (_init = Object.getOwnPropertyDescriptor(_obj, "groupClass"), _init = _init ? _init.value : undefined, {
  enumerable: true,
  configurable: true,
  writable: true,
  initializer: function () {
    return _init;
  }
}), _obj), _applyDecoratedDescriptor(_obj, "groupPath", [_dec4], Object.getOwnPropertyDescriptor(_obj, "groupPath"), _obj), _applyDecoratedDescriptor(_obj, "close", [action], Object.getOwnPropertyDescriptor(_obj, "close"), _obj), _applyDecoratedDescriptor(_obj, "handleShowGroup", [action], Object.getOwnPropertyDescriptor(_obj, "handleShowGroup"), _obj)), _obj))));